import {
  applyUtcFormatWithoutConverting,
  convertDateToMilliseconds,
} from '../../utils/timeFormats';

const recalculateLaf = (flight, filteredDetails) => {
  return {
    ...flight,
    details: filteredDetails,
    lowestAvailableFare: filteredDetails.reduce((previousDetail, currentDetail) =>
      previousDetail.pricePerPassenger.value < currentDetail.pricePerPassenger.value
        ? previousDetail
        : currentDetail,
    ).pricePerPassenger,
  };
};

const getCompliesWithStopsFilters = (filters, flight) => {
  const numberOfStops = flight.flightSegments.length - 1;
  return !(
    filters.stops.nonStop.selected ||
    filters.stops.oneStop.selected ||
    filters.stops.twoStops.selected
  )
    ? true
    : (filters.stops.nonStop.selected && numberOfStops === 0) ||
        (filters.stops.oneStop.selected && numberOfStops === 1) ||
        (filters.stops.twoStops.selected && numberOfStops > 1);
};

const getCompliesWithTimesFilters = (
  filters,
  departDateInMilliseconds,
  arrivalDateInMilliseconds,
) => {
  const { takeOff, landing } = filters.flightTimes;

  const isTakeOffInRange =
    departDateInMilliseconds >= takeOff.selected[0] &&
    departDateInMilliseconds <= takeOff.selected[1];

  const isLandingInRange =
    arrivalDateInMilliseconds >= landing.selected[0] &&
    arrivalDateInMilliseconds <= landing.selected[1];

  return isTakeOffInRange && isLandingInRange;
};

const getCompliesWithAirlineFilters = (selectedAirlinesFilters, flight) => {
  return selectedAirlinesFilters.length === 0
    ? true
    : flight.flightSegments.some((flightSegment) =>
        selectedAirlinesFilters.some((airlineFilter) => {
          return airlineFilter.code === flightSegment.marketingAirline.code;
        }),
      );
};
const applyFiltersToFlight = (filters, flight) => {
  const compliesWithStopsFilters = getCompliesWithStopsFilters(filters, flight);

  const departDateInMilliseconds = convertDateToMilliseconds(
    applyUtcFormatWithoutConverting(`${flight.departDate} ${flight.departTime}`),
  );

  const arrivalDateInMilliseconds = convertDateToMilliseconds(
    applyUtcFormatWithoutConverting(`${flight.arrivalDate} ${flight.arrivalTime}`),
  );

  const compliesWithTimesFilters = getCompliesWithTimesFilters(
    filters,
    departDateInMilliseconds,
    arrivalDateInMilliseconds,
  );

  const selectedAirlinesFilters = filters.airlines.filter(
    (airlineFilter) => airlineFilter.selected,
  );

  const compliesWithAirlineFilters = getCompliesWithAirlineFilters(selectedAirlinesFilters, flight);

  const selectedClassFilters = filters.classes.filter(
    (classFilter) => !classFilter.disabled && classFilter.selected,
  );

  const filteredDetails = flight.details.filter((detail) =>
    selectedClassFilters.some((classFilter) => classFilter.code === detail.cabinClass.code),
  );

  const compliesWithClassFilters =
    selectedClassFilters.length === 0 ? true : filteredDetails.length > 0;

  if (
    compliesWithStopsFilters &&
    compliesWithTimesFilters &&
    compliesWithAirlineFilters &&
    compliesWithClassFilters
  ) {
    const recalculatedFlight =
      selectedClassFilters.length === 0 ? flight : recalculateLaf(flight, filteredDetails);

    const fareValue = recalculatedFlight && recalculatedFlight.lowestAvailableFare.value;

    if (
      recalculatedFlight &&
      fareValue >= filters.minMaxPrice.selected[0] &&
      fareValue <= filters.minMaxPrice.selected[1]
    ) {
      return recalculatedFlight;
    }
  }

  return null;
};

const applyFiltersToSearchResults = (filters, searchResultsVar) => {
  const searchResults = searchResultsVar();
  const flights = searchResults ? searchResults.matchingFlights : [];
  const filteredFlights = [];
  flights.forEach((flight) => {
    const filteredFlight = applyFiltersToFlight(filters, flight);
    if (filteredFlight) {
      filteredFlights.push(filteredFlight);
    }
  });
  return filteredFlights;
};

const defaultClassFilters = [
  {
    code: 'Y',
    defaultName: 'Economy',
    disabled: true,
    selected: false,
  },
  {
    code: 'S',
    defaultName: 'Premium Economy',
    disabled: true,
    selected: false,
  },
  {
    code: 'C',
    defaultName: 'Business',
    disabled: true,
    selected: false,
  },
  {
    code: 'F',
    defaultName: 'First Class',
    disabled: true,
    selected: false,
  },
];

export { applyFiltersToSearchResults, defaultClassFilters };
